export const INSTANCES_PERIOD_TOUR_DATA = new Map();
INSTANCES_PERIOD_TOUR_DATA.set(
  15,
  'year-to-year, last quarter, last month or last week.'
).set(30, 'year-to-date, period-to-date or latest quarter.');
